let Oidc = null;
let mgr = null;
class SecurityService { }

if (process.env.VUE_APP_PROVIDER === 'authAPIM') {
  Oidc = require('oidc-client');

  mgr = new Oidc.UserManager({
    userStore: new Oidc.WebStorageStateStore({ store: window.localStorage }),
    authority: process.env.VUE_APP_APIM_AUTHORITY,
    client_id: process.env.VUE_APP_APIM_CLIENT_ID,
    redirect_uri: process.env.VUE_APP_APIM_REDIRECT_URI,
    response_type: 'code',
    scope: process.env.VUE_APP_APIM_SCOPE,
    post_logout_redirect_uri: process.env.VUE_APP_APIM_REDIRECT_URI,
    silent_redirect_uri: process.env.VUE_APP_APIM_SILENT_REDIRECT_URI,
    client_secret: process.env.VUE_APP_APIM_CLIENT_SECRET,
    filterProtocolClaims: true,
    accessTokenExpiringNotificationTime: 10,
    automaticSilentRenew: true,

    loadUserInfo: false,
    signingKeys: JSON.parse(process.env.VUE_APP_APIM_SIGNINGKEYS),
    metadata: {
      authorization_endpoint: process.env.VUE_APP_APIM_AUTHORIZATION_ENDPOINT,
      prompt: 'none',
      issuer: process.env.VUE_APP_APIM_ISSUER,
      token_endpoint: process.env.VUE_APP_APIM_TOKEN_ENDPOINT,
      end_session_endpoint: process.env.VUE_APP_APIM_END_SESSION_ENDPOINT
    }
  });

  mgr.events.addUserLoaded(function (user) {
    return user;
  });

  mgr.events.addAccessTokenExpiring(function () {
  });

  mgr.events.addAccessTokenExpired(function () {
    mgr.signoutRedirect(
    ).then(function (resp) {
      return resp;
    }).catch(function (err) {
      console.error(err)
    })
  });

  mgr.events.addSilentRenewError(function () {
    console.error('Silent Renew Error：', arguments);
  });

  mgr.events.addUserSignedOut(function () {
    mgr.signoutRedirect(
    ).then(function (resp) {
      return resp;
    }).catch(function (err) {
      console.error(err);
    })
  });

  SecurityService.prototype.renewToken = () => {
    return new Promise((resolve, reject) => {
      mgr.signinSilentCallback().then(function () {
      }).catch(function (err) {
        return reject(err)
      });
    })
  }

  SecurityService.prototype.signOut = () => {
    mgr.signoutRedirect(
    ).then(function (resp) {
      return resp
    }).catch(function (err) {
      throw err;
    })
  };

  SecurityService.prototype.removeUser = async () => {
    mgr.removeUser()
  };

  SecurityService.prototype.getUser = () => {
    return new Promise((resolve, reject) => {
      mgr.getUser().then(function (user) {
        if (user == null) {
          return resolve(null)
        } else {
          if (!user.state) {
            return resolve(user)
          } else {
            return resolve(user)
          }
        }
      }).catch(function (err) {
        return reject(err)
      });
    })
  };

  SecurityService.prototype.signIn = () => {
    return new Promise((resolve, reject) => {
      mgr.signinRedirect(
      ).then(function (resp) {
        return resolve(resp)
      }).catch(function (err) {
        return reject(err)
      });
    })
  };

  SecurityService.prototype.getAcessToken = () => {
    return new Promise((resolve, reject) => {
      mgr.getUser().then(function (user) {
        if (user == null) {
          return resolve(null)
        } else {
          return resolve(user.access_token)
        }
      }).catch(function (err) {
        return reject(err)
      });
    })
  };

  SecurityService.prototype.signinRedirectCallback = async function () {
    let self = this;

    return new Promise((resolve, reject) => {
      mgr.signinRedirectCallback().then(function (user) {

        if (user == null) {
          self.signIn()
        } else {
          return resolve(user)
        }
      }).catch(function (err) {

        return reject(err)
      });
    })
  }
}

export default SecurityService;

